import React from 'react';
import MetaBox from 'src/components/atoms/MetaBox';
import { useLabels } from 'src/StoreDataProvider';
import { ProjectMetaBoxesProps } from './projectMetaBoxes.types';

const ProjectMetaBoxes: (props: ProjectMetaBoxesProps) => JSX.Element = ({
  country,
  year,
  rating,
}) => {
  const labels = useLabels();
  return (
    <p style={{ display: 'flex' }} className="project-tile-meta-boxes">
      <MetaBox type="country">{country}</MetaBox>
      <MetaBox type="year">{year}</MetaBox>
      <MetaBox type="rating">
        {labels.rating} {rating}
      </MetaBox>
    </p>
  );
};

export default ProjectMetaBoxes;
